var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 0.231918L6 5.00889L1.35999 0.231918C1.20864 0.081423 1.00593 -0.00185115 0.795519 3.12318e-05C0.585108 0.00191361 0.383833 0.0888018 0.235044 0.241982C0.0862558 0.395162 0.00185875 0.602379 3.03363e-05 0.819C-0.00179808 1.03562 0.0790885 1.24432 0.225269 1.40014L5.43023 6.75874C5.50487 6.8359 5.5937 6.89698 5.69153 6.9384C5.78936 6.97982 5.89422 7.00076 6 6.99998C6.10574 7.00053 6.21055 6.97949 6.30834 6.93808C6.40614 6.89667 6.495 6.83572 6.56977 6.75874L11.7747 1.40014C11.9209 1.24432 12.0018 1.03562 12 0.819C11.9981 0.602379 11.9137 0.395162 11.765 0.241982C11.6162 0.0888018 11.4149 0.00191361 11.2045 3.12318e-05C10.9941 -0.00185115 10.7914 0.081423 10.64 0.231918Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownArrow);
export default __webpack_public_path__ + "static/media/icon-dropdown-arrow.f8ba0f83c40194157d82731b0134b504.svg";
export { ForwardRef as ReactComponent };